export default "__VITE_ASSET__911b20bd__"